var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlcoholic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#9CA3AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#8B0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5956 8.55689L25.5956 8.55686C25.5264 8.43669 25.3983 8.3625 25.2596 8.3625H15.7301C15.5914 8.3625 15.4633 8.43669 15.3942 8.55686L15.3941 8.55689C14.1218 10.7686 13.3625 13.5704 13.3625 16.0592C13.3625 18.1275 13.9125 19.8101 14.9678 21.0224C15.991 22.1979 17.471 22.9104 19.3277 23.1167V28.8045L16.3653 30.9353L16.3652 30.9354C16.2287 31.0337 16.1712 31.209 16.2227 31.3688L16.2228 31.369C16.2745 31.5291 16.4233 31.6375 16.5916 31.6375H24.3981C24.5664 31.6375 24.7152 31.5291 24.767 31.369L24.767 31.3688C24.8185 31.209 24.761 31.0337 24.6245 30.9354L24.6244 30.9353L21.662 28.8045V23.1167C23.5188 22.9104 24.9988 22.1979 26.022 21.0224C27.0773 19.8101 27.6272 18.1275 27.6272 16.0592C27.6272 13.5704 26.8679 10.7686 25.5956 8.55689ZM20.1027 29.0029V23.1734C20.2301 23.1796 20.3606 23.1843 20.4949 23.1843C20.6291 23.1843 20.7596 23.1796 20.887 23.1734V29.0029C20.887 29.1282 20.9475 29.2444 21.0475 29.3171L21.0482 29.3176L23.1959 30.8625H17.7939L19.9415 29.3176L19.9423 29.3171C20.0422 29.2444 20.1027 29.1282 20.1027 29.0029ZM20.6102 15.2549L20.6102 15.2549C17.6948 14.3464 15.2471 14.6451 14.1991 14.8525C14.3877 12.9006 15.0132 10.8459 15.9565 9.1375H25.0333C26.0221 10.9285 26.6609 13.0995 26.8138 15.134C26.1458 15.4508 23.9176 16.2856 20.6102 15.2549ZM20.3795 15.9949L20.3795 15.9949C21.6616 16.3942 22.7931 16.5368 23.7551 16.5368C25.1936 16.5368 26.2469 16.2183 26.8508 15.9693C26.8517 15.999 26.8522 16.0288 26.8522 16.0592C26.8522 18.8538 25.8491 20.4249 24.5779 21.307C23.2935 22.1983 21.7024 22.4093 20.4949 22.4093C19.2874 22.4093 17.6963 22.1983 16.4118 21.307C15.1406 20.4249 14.1375 18.8538 14.1375 16.0592C14.1375 15.9274 14.1437 15.7942 14.1506 15.6561C14.9668 15.478 17.4485 15.0812 20.3795 15.9949Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlcoholic);
export default __webpack_public_path__ + "static/media/ic_alcoholic.de825d768ef2979d9285f19664239426.svg";
export { ForwardRef as ReactComponent };